import styles from "./index.module.scss";
import { NextPage } from "next";
import StockTradingSignals from "@/components/stock-trading-signals/StockTradingSignals";
import { Stock } from "@/models/stock";
import Head from "next/head";
import { buildStockOgImage } from "@/lib/stock-og";
import { useSetAtom } from "jotai";
import { stockTradingItemIdState } from "@/lib/store";
import { useEffect } from "react";
import { stockPageGetServerSideProps } from "@/lib/stock-page-ssr";
import { stockCanonicalUrl } from "@/lib/stock-url";

const StockTradingSignalsPage: NextPage<{ stock: Stock }> = ({ stock }) => {
    const setStockTradingItemId = useSetAtom(stockTradingItemIdState);

    useEffect(() => {
        stock ? setStockTradingItemId(stock.tradingitem_id) : setStockTradingItemId(null);
    }, [stock]);

    return (
        <>
            {stock &&
                (() => {
                    const { ogImageUrl, cardTitle } = buildStockOgImage(stock, "Trading Signals");
                    return (
                        <Head>
                            <title>{`${stock.name}, ${stock.exchangesymbol}:${stock.ticker} | Trading Signals | ORTEX`}</title>
                            <link rel="canonical" href={stockCanonicalUrl(stock, "trading-signals")} />
                            <meta name="keywords" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker}, Trading Signals, Alpha Signals, Short Signals, Trading Suggestions, Stock Picks`} />
                            <meta name="description" content={`Trading Signals in ${stock.name}, ${stock.exchangesymbol}:${stock.ticker}`} />
                            <meta name="twitter:card" content="summary_large_image" />
                            <meta name="twitter:title" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker} | Trading Signals | ORTEX`} />
                            <meta name="twitter:description" content={`Trading Signals in ${stock.name}, ${stock.exchangesymbol}:${stock.ticker}`} />
                            <meta name="twitter:url" content={stockCanonicalUrl(stock, "trading-signals")} />
                            <meta name="twitter:image" content={ogImageUrl} />
                            <meta name="twitter:image:alt" content={cardTitle} />
                            <meta property="og:title" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker} | Trading Signals | ORTEX`} />
                            <meta property="og:description" content={`Trading Signals in ${stock.name}, ${stock.exchangesymbol}:${stock.ticker}`} />
                            <meta property="og:url" content={stockCanonicalUrl(stock, "trading-signals")} />
                            <meta property="og:image" content={ogImageUrl} key="og:image" />
                            <meta property="og:image:width" content="1200" />
                            <meta property="og:image:height" content="630" />
                            <meta property="og:image:alt" content={cardTitle} />
                        </Head>
                    );
                })()}
            <div className={styles.StockTradingSignalsPage}>{stock ? <StockTradingSignals stock={stock} /> : <h1>Stock not found.</h1>}</div>
        </>
    );
};

export const getServerSideProps = stockPageGetServerSideProps({ tab: "trading-signals" });

export default StockTradingSignalsPage;
